import React from "react";
import { Container, Typography, Paper, Box } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Link } from "react-router-dom";
import SplitDescription from "../components/splitdescription";
import TransformComponent from "../components/transformcomp";
import WhyTecloqCards from "../components/whytecloqcards";

const whyTecloqGrid = [
    {
      src: "/assets/AdvancedAI/DataScience/why1.gif",
      alt: "why1",
      title: "Industry Wide<br />Experience",
      description:
        "Tecloq is a Data Science & Analytics consulting firm that offers start-ups and Fortune 100 corporations world-class solutions, with an emphasis on ISV’s, media publishers, and retail service providers, since 2014.",
    },
    {
      src: "/assets/AdvancedAI/DataScience/why2.gif",
      alt: "why2",
      title: "Scalable<br />Applications",
      description:
        "Our machine learning algorithms and data mining approaches will aid in the development of scalable structures and machine learning pipelines in software and web applications for your business cases.",
    },
    {
      src: "/assets/AdvancedAI/DataScience/why3.gif",
      alt: "why3",
      title: "Skilled<br />Specialists",
      description:
        "Our data scientists are experts in their fields, with skills in predictive analytics, data pipelines, machine learning, and more, and can help you achieve your data science goals from beginning to end.",
    },
  ]

const dataScienceItems = [
  {
    src: "/assets/AdvancedAI/DataScience/support.gif",
    alt: "Strategic support",
    width: "58%",
    paddingTop: "3%",
    text: "Strategic support",
  },
  {
    src: "/assets/AdvancedAI/DataScience/npl.gif",
    alt: "NLP Expertise",
    width: "65%",
    paddingTop: "0",
    text: "NLP Expertise",
  },
  {
    src: "/assets/AdvancedAI/DataScience/machinelearn.gif",
    alt: "Machine learning Models",
    width: "50%",
    paddingTop: "10%",
    text: "Machine learning <br /> Models",
  },
  {
    src: "/assets/AdvancedAI/predictivegif.gif",
    alt: "Predictive Analytics",
    width: "50%",
    paddingTop: "8%",
    text: "Predictive <br /> Analytics",
  },
  {
    src: "/assets/AdvancedAI/DataScience/visual.gif",
    alt: "Analytics & Visualization",
    width: "50%",
    paddingTop: "8%",
    text: "Analytics & <br /> Visualization",
  },
  {
    src: "/assets/AdvancedAI/DataScience/dwpipeline.gif",
    alt: "Data Warehouse & Pipelines",
    width: "50%",
    paddingTop: "8%",
    text: "Data Warehouse &<br /> Pipelines",
  },
];

const AIDataScience = () => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", overflowX: "hidden" }}>
      <Container
        sx={{
          backgroundImage:
            'url("/assets/AdvancedAI/DataScience/background.webp")',
          backgroundPosition: "center",
          backgroundSize: "cover",
          maxWidth: "100% !important",
          height: { xs: "380px", sm: "450px", md: "480px" }, // Responsive height
          display: "flex",
          overflowX: "hidden",
          margin: "0 !important",
          alignItems: "center", // Center content vertically
          justifyContent: "center", // Center content horizontally
          padding: { xs: "20px", sm: "40px", md: "90px" }, // Responsive padding
        }}
      >
        <section
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "flex-start", // Left align content
            width: "100%",
            maxWidth: { xs: "90%", sm: "80%", md: "70%" }, // Responsive width
          }}
        >
          {/* Heading */}
          <Typography
            sx={{
              fontFamily: "Orbitron",
              fontWeight: "800",
              fontSize: { xs: "18px", sm: "22px", md: "24px" }, // Responsive font size
              color: "#FFFFFF",
              lineHeight: "120%",
              letterSpacing: "2%",
              paddingBottom: { xs: "10px", sm: "15px", md: "20px" },
            }}
          >
            Data-Driven Growth and Transformation
          </Typography>

          {/* Subheading */}
          <Typography
            sx={{
              fontFamily: "Orbitron",
              fontWeight: "800",
              fontSize: { xs: "28px", sm: "48px", md: "60px" }, // Responsive font size
              color: "#F005A2",
              lineHeight: "120%",
              letterSpacing: "2%",
              paddingBottom: { xs: "10px", sm: "15px", md: "20px" },
            }}
          >
            Data Science Solutions & Services
          </Typography>

          {/* Description */}
          <Typography
            sx={{
              fontFamily: "Orbitron",
              fontWeight: "800",
              fontSize: { xs: "16px", sm: "20px", md: "24px" }, // Responsive font size
              color: "#FFFFFF",
              lineHeight: "140%",
              letterSpacing: "2%",
              paddingBottom: { xs: "15px", sm: "20px", md: "25px" },
            }}
          >
            Build new experiences for your stakeholders, improve business
            processes, and get data-driven insights that lead to actionable
            results with Tecloq.
          </Typography>

          {/* Button */}
          <Link
            to="/clientForm"
            style={{
              display: "flex",
              width: "fit-content",
              padding: "12px 24px", // Responsive padding
              backgroundColor: "#F005A2",
              borderRadius: "45px",
              alignItems: "center",
              justifyContent: "center",
              textDecoration: "none",
              color: "inherit",
            }}
          >
            <div
              style={{
                fontFamily: "'Plus Jakarta Sans', sans-serif",
                fontSize: { xs: "14px", sm: "16px", md: "18px" }, // Responsive font size
                letterSpacing: "0.08em",
                fontWeight: "700",
              }}
            >
              Talk to Us
            </div>
            <div
              className="submitBtn__Arrow"
              style={{
                width: { xs: "28px", sm: "32px" }, // Responsive size
                height: { xs: "28px", sm: "32px" }, // Responsive size
                backgroundColor: "#FFFFFF",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginLeft: "10px",
              }}
            >
              <ArrowForwardIcon
                style={{
                  fontSize: { xs: "18px", sm: "24px" }, // Responsive size
                }}
              />
            </div>
          </Link>
        </section>
      </Container>

      <SplitDescription
        heading1={"Boost the Value of your Entire Business - with Data"}
        heading2={`Our Data Scientists help you build "data-to-action" pipelines`}
        content1={`The amount of data we generate each year grows exponentially. When
            used correctly, data may lead to better decision-making, increased
            operational efficiency, and superior business insights. Data science
            is a broad, interdisciplinary field that makes use of the vast
            amounts of data and processing power at its disposal to generate
            insights while employing a wide range of scientific methods,
            algorithms, and processes. When we evaluate this data, we acquire
            significant insights into the industry or customer dynamics,
            allowing the organization to gain a competitive advantage over its
            competitors by identifying trends in data collection.`}
        content2={`By integrating a variety of tools, our data scientists reap the
            essence of information hidden in your complicated and raw data,
            allowing you to unleash successful campaign delivery and revenue
            prospects into your organization. Tecloq enables firms to estimate
            the next optimal profit decision using advanced technologies such as
            consumer analytics, natural language processing, and pattern
            identification techniques.`}
        img1={"/assets/AdvancedAI/DataScience/dataFiles.png"}
        img2={"/assets/AdvancedAI/DataScience/pipeline.webp"}
      />

      <Box
        sx={{
          maxWidth: "100% !important",
          height: "auto",
          marginTop: { xs: "12%", md: "8%" }, // More margin on smaller screens for better spacing
        }}
      >
        <Typography
          sx={{
            fontFamily: "Orbitron",
            fontWeight: "800",
            fontSize: { xs: "24px", sm: "30px", md: "40px" }, // Responsive font size
            color: "#000000",
            lineHeight: "120%",
            letterSpacing: { xs: "1%", md: "2%" }, // Adjust letter spacing for mobile
            display: "flex",
            justifyContent: "center",
            paddingBottom: { xs: "4%", md: "1%" }, // More padding at the bottom for smaller screens
            textAlign: "center", // Ensure centering on all screen sizes
          }}
        >
          Our Data Science Services & Solutions Offerings
        </Typography>
      </Box>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "repeat(2, 1fr)", md: "repeat(3, 1fr)" }, // Adjust for mobile and desktop
          gap: "20px",
          justifyContent: "center",
          padding: "0 5%",
        }}
      >
        {dataScienceItems.map((item, index) => (
          <Paper
            key={index}
            elevation={3}
            sx={{
              borderRadius: "5%",
              textAlign: "center",
              padding: "3%",
            }}
          >
            <img
              src={item.src}
              alt={item.alt}
              style={{
                boxSizing: "border-box",
                width: item.width,
                height: "auto",
                paddingTop: item.paddingTop,
              }}
            />
            <Typography
              sx={{
                fontFamily: "Inter",
                fontWeight: "700",
                fontSize: { xs: "14px", md: "16px" },
                lineHeight: "21px",
                textAlign: "center",
                color: "#000000",
                paddingTop: "5%",
              }}
              dangerouslySetInnerHTML={{ __html: item.text }}
            />
          </Paper>
        ))}
      </Box>

      <Box
        sx={{
          maxWidth: "100%",
          height: "auto",
          marginTop: "6%",
          paddingX: { xs: "5%", md: "0" }, // Add padding for smaller screens
        }}
      >
        <Typography
          sx={{
            fontFamily: "Orbitron",
            fontWeight: "800",
            fontSize: { xs: "24px", md: "40px" }, // Adjust font size for mobile
            color: "#000000",
            lineHeight: "120%",
            letterSpacing: "2%",
            display: "flex",
            justifyContent: "center",
            paddingBottom: "1%",
          }}
        >
          Why Tecloq?
        </Typography>
        <Typography
          sx={{
            fontFamily: "Inter",
            fontWeight: "lighter",
            fontSize: { xs: "14px", md: "20px" }, // Adjust font size for mobile
            color: "#000000",
            display: "flex",
            justifyContent: "center",
            margin: { xs: "3% 5%", md: "1% 15% 2% 15%" }, // Adjust margin for different screen sizes
            textAlign: "center",
          }}
        >
          Tecloq is one of the top Data Science Consulting Firms, providing
          AI-powered software and technical solutions to businesses that want to
          use data and machine learning algorithms to improve their bottom line.
          Our Data Science Services & Solutions assist businesses in conducting
          data experiments in order to uncover business insights. Tecloq
          provides Data Science Solutions & Services based on Machine Learning,
          Artificial Intelligence, and Deep Learning to meet our clients’ most
          specific analytics requirements.
        </Typography>
      </Box>

      <WhyTecloqCards data={whyTecloqGrid}/>

      <TransformComponent />
    </Box>
  );
};

export default AIDataScience;
